import { Box, Theme, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { WitboostPaletteColor } from '../../themes';

export type WbBadgeVariant = 'soft' | 'bright' | 'stroke' | 'disabled';

type VariantProps = { variant?: WbBadgeVariant; color?: WitboostPaletteColor };
import { FC, HTMLProps } from 'react';

export type WbBadgeProps = HTMLProps<HTMLDivElement> & VariantProps;

const useStyles = makeStyles<Theme, VariantProps>(
  theme => ({
    root: ({ color = 'primary', variant = 'soft' }) => {
      let variantProps: React.CSSProperties = {};

      switch (variant) {
        default:
        case 'soft':
          variantProps = {
            backgroundColor: theme.palette.softened[color],
          };
          break;
        case 'stroke':
          variantProps = {
            backgroundColor: theme.palette.bkg[color],
            border: `1px ${theme.palette[color]?.light} solid`,
          };
          break;
        case 'bright':
          variantProps = {
            backgroundColor: theme.palette[color].main,
          };
          break;
        case 'disabled':
          variantProps = {
            backgroundSize: '8px 8px',
            backgroundColor: theme.palette.blueGrey[100],
            backgroundImage: `repeating-linear-gradient(-45deg,${theme.palette.blueGrey[100]} 0,${theme.palette.blueGrey[100]} 4px,#b0b0b0 5px,#b0b0b0 5.5px)`,
          };
      }

      const textColor = theme.palette.getContrastText(
        variantProps.backgroundColor ?? theme.palette.white,
      );

      return {
        borderRadius: theme.spacing(0.5),
        padding: `${theme.spacing(0.25)}px ${theme.spacing(0.75)}px`,
        ...theme.typography.body2,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        width: 'fit-content',
        display: 'inline-block',
        color: textColor,
        ...(variantProps as any),
      };
    },
  }),
  { name: 'WbBadge' },
);

export const WbBadge: FC<WbBadgeProps> = ({
  className,
  children,
  color,
  variant,
  ...props
}) => {
  const classes = useStyles({ color, variant });
  return (
    <Box className={clsx(classes.root, className)} {...props}>
      {children}
    </Box>
  );
};
